import React, { useContext } from "react";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import Keycloak from "keycloak-js";
import axiosInstance from "../api/AxiosInstance";

import { UserContext } from "../context/UserContext"
import { useNavigate } from "react-router-dom";

const keycloak = new Keycloak({
  url: "/auth",
  realm: 'JobBit',
  clientId: 'jobbit-ui'
});

const Auth = (props) => {
  const { setUser } = useContext(UserContext);
  let navigate = useNavigate();

  const initialOptions = {
    onLoad: 'login-required',
    pkceMethod: 'S256',
    enableLogging: true,
    checkLoginIframe: false,
    checkLoginIframeInterval: 10
  }

  const onTokens = (tokens) => {
    const userData = {
      id: keycloak.tokenParsed.sub,
      email: keycloak.tokenParsed.email,
      firstName: keycloak.tokenParsed.given_name,
      lastName: keycloak.tokenParsed.family_name,
      isAdmin: keycloak.tokenParsed.realm_access.roles.includes("admin"),
      isManager: keycloak.tokenParsed.realm_access.roles.includes("manager"),
      isRecruiter: keycloak.tokenParsed.realm_access.roles.includes("recruiter"),
      hasLoaded: true
    }
    setUser(userData);

    axiosInstance.setAuthToken(tokens.token);
  }


  return (
    <ReactKeycloakProvider
      authClient={keycloak}
      initOptions={initialOptions}
      LoadingComponent={<div />}
      isLoadingCheck={() => !keycloak.authenticated}
      onTokens={onTokens}>
      {props.children}
    </ReactKeycloakProvider>)
}

export default Auth;
